import { ReactNode, useEffect, useReducer } from "react";
import {
  ChickenNuggetsContext,
  initialState,
  reducer,
  NuggetsType,
  ChickenNuggetsActionKeys,
} from "./ChickenNuggetsContext";

type ChickenNuggetsProviderProps = {
  /** Array of { id: string; onClick?: (args: string) => } */
  nuggets: NuggetsType[];
  children: ReactNode;
  index: number;
};

export const ChickenNuggetsProvider = ({
  nuggets,
  children,
  index,
}: ChickenNuggetsProviderProps) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    activeIndex: index,
  });

  useEffect(() => {
    dispatch({
      type: ChickenNuggetsActionKeys.ActiveIndex,
      payload: index,
    });
  }, [index]);

  return (
    <ChickenNuggetsContext.Provider
      value={{
        nuggets,
        state,
        dispatch,
      }}
    >
      {children}
    </ChickenNuggetsContext.Provider>
  );
};
